import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from 'react-bootstrap/Container';
import { NavLink } from "react-router-dom";
// import Trending from '../../components/TrendingNow/Trending';
import axios from "axios";
// import Form from "react-bootstrap/Form";
// import TabContainer from "react-bootstrap/TabContainer";
// import Button from 'components/Button/Button';
//import { HeaderConfig } from "Api/Api";
//import { user_Status, search_Presentation_API } from "Api/Api";
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
import { searchUrl } from "Api/Api";
// import { current_unix_stamp } from "utils/Helper";
// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import Footer from '../../components/Footer/Footer';
// import FavouriteModal from 'components/FavoriteModal/FavoriteModal';
// import Modal from "react-bootstrap/Modal";
import { local_routes } from 'utils/Routes';
import home from 'Assets/home.svg';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar, momentLocalizer } from 'react-big-calendar';
//import dates from "react-big-calendar/lib/utils/dates";
import moment from 'moment';

const localizer = momentLocalizer(moment);

class EventCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            cur_view: 'month',
            year: '',
            years_options: [],
            cur_date: new Date(),
            //cal_date: new Date(),
            loading: true,
            events_month_count: null
        };

        // setup years dropdown
        let cur_date = new Date();
        let cur_year = cur_date.getFullYear();
        let first_year = 2003;
        this.years_options = [];
        for (let year = cur_year; year >= first_year; year-- ) {
            this.years_options.push(year);
        }

        // adjust big-calendar date display formats
        this.formats = {
            dayHeaderFormat: "dddd MMM D, YYYY",
            dayRangeHeaderFormat: ({ start, end }, culture, locale) =>
            locale.format(start, 'MMMM D, YYYY', culture) +
            ' – ' +
            locale.format(end, 'MMMM D YYYY', culture)
        };
    }

    MainAPICall = async (search_date) => {
        let search_start_time = Math.floor(search_date.getTime() / 1000) - 5184000; // 60 days
        let search_end_time = Math.floor(search_date.getTime() / 1000) + 5184000; // 60 days
        
        /*
        let cal_date;
        if (!search_start_date || !search_end_date) {
            cal_date = this.state.cal_date;
            search_start_time = current_unix_stamp - 5184000; // 2 months
            search_end_time = current_unix_stamp + 5184000; // 2 months
        } else {
            cal_date = search_start_date;
            search_start_time = Math.floor(search_start_date.getTime() / 1000);
            search_end_time = Math.floor(search_end_date.getTime() / 1000);
        }
        */
        
        let api_promises = [];
        api_promises.push(axios.get(`${searchUrl}eventsearch?limit=1000&search_start_time=${search_start_time}&search_end_time=${search_end_time}`));
        
        // get event count for current month, if in month view
        if (this.state.cur_view === 'month') {
            // let cur_date = new Date();
            let firstDay = new Date(search_date.getFullYear(), search_date.getMonth(), 1);
            let lastDay = new Date(search_date.getFullYear(), search_date.getMonth() + 1, 0);
            let tmp_search_start_time = Math.floor(firstDay.getTime() / 1000); // 60 days
            let tmp_search_end_time = Math.floor(lastDay.getTime() / 1000); // 60 days
            api_promises.push(axios.get(`${searchUrl}eventsearch?limit=1000&search_start_time=${tmp_search_start_time}&search_end_time=${tmp_search_end_time}`));
        }        
        
        //let events_response = await axios.get(`${searchUrl}eventsearch?locations_text=all&limit=1000&search_start_time=${search_start_time}&search_end_time=${search_end_time}`);
        
        let [events_response,events_month_response] = await Promise.all(api_promises);
        
        let events_raw = events_response.data.search_query_results.map((data) => data.entity_info);
        
        let events_month_count = 0;
        
        if (events_month_response) {
            let events_month_raw = events_month_response.data.search_query_results.map((data) => data.entity_info);
            events_month_count = events_month_raw.length;
        }
        
        let tmp_events = [];
        for (let event_obj of events_raw) {
            let tmp_event_name = event_obj.entity_name;
            if (event_obj.volume_integer) {
                tmp_event_name = tmp_event_name+' (#'+event_obj.volume_integer+')';
            }
            
            let tmp_end_time = event_obj.end_time;
            
            if (event_obj.end_time - event_obj.start_time > 10800) {
                // event too long (> 3h)
                tmp_end_time = event_obj.start_time + 10800;
            } else if (event_obj.end_time - event_obj.start_time < 900) {
                // event too short (< 15m)
                tmp_end_time = event_obj.start_time + 900;
            }
            //let tmp_end_time = (event_obj.start_time * 1000) + 1;
            let calendar_event_obj = {
                friendly_url: event_obj.friendly_url,
                id: event_obj.entity_uuid,
                title: tmp_event_name,
                start: new Date(event_obj.start_time*1000),
                end: new Date(tmp_end_time * 1000)
                //end: new Date((event_obj.start_time+7200)*1000)
            };
            tmp_events.push(calendar_event_obj);
        }
        

        this.setState({ cur_date: search_date, events_month_count, events:tmp_events,loading:false});
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.MainAPICall(new Date());
    }

    onSelectEvent = (event) => {
        this.props.history.push(local_routes.events+"/"+event.friendly_url);
    }

    /*
    onRangeChange = (range_dates) => {
        console.log("onRangeChange",range_dates);
        this.setState({ loading: true });
        this.MainAPICall(range_dates.start,range_dates.end);
    }
    */

    onView = (new_view) => {
        console.log("onView",new_view);
        this.setState({ cur_view: new_view });
        //this.MainAPICall(new_date);
    }

    onNavigate = (new_date) => {
        console.log("onNavigate",new_date);
        //this.setState({ cur_date: new_date });
        //this.setState({ loading: true });
        this.MainAPICall(new_date);
    }
    
    handleChangeYear = (e) => {
        console.log("handleChangeYear",e.target.value);
        this.setState({ year: e.target.value});
        let new_date = new Date;
        new_date.setFullYear(e.target.value);
        //this.setState({ loading: true });
        //this.setState({ cur_date: new_date });
        this.MainAPICall(new_date);
    }

    render() {

        if (this.state.loading) {
            return (
                <FullPageSpinner />
            );
        }

        return (
            <React.Fragment>
                <Helmet>
                    <title>PechaKucha Event Calendar</title>
                    <meta name="description" content="All PechaKucha Events around the world, on one calendar." />
                </Helmet>
                <div>
                    <Container>
                        <Row>
                            <Col>
                                <NavLink style={{ fontSize: "smaller", marginTop: "5px" }} to={local_routes.events}>Back to Events (Map)</NavLink>
                                <Calendar
                                    showMultiDayTimes={false}
                                    onSelectEvent={this.onSelectEvent}
                                    //onRangeChange={this.onRangeChange}
                                    localizer={localizer}
                                    events={this.state.events}
                                    date={this.state.cur_date}
                                    onView={this.onView}
                                    //defaultDate={this.state.cur_date}
                                    onNavigate={this.onNavigate}
                                    //startAccessor="start"
                                    //endAccessor="end"
                                    style={{ height: 800, fontSize: "smaller", marginTop: "20px" }}
                                    formats={this.formats}
                                />
                            </Col>
                        </Row>
                        { this.state.cur_view === 'month' && this.state.events_month_count &&
                            <Row style={{ fontSize: "smaller", float: "left", marginTop: "10px" }}>
                                <Col>
                                    {this.state.events_month_count} Events ({this.state.cur_date.getMonth()+1}/{this.state.cur_date.getFullYear()})
                                </Col>
                            </Row>
                        }
                        <Row style={{ fontSize: "smaller", float: "right", marginTop: "10px" }}>
                            <Col>
                                Jump to year:&nbsp;
                                <select value={this.state.year} onChange={this.handleChangeYear}>
                                    {this.years_options.map((item, i) => {
                                        return (
                                            <option key={item} value={item}>{item}</option>
                                        );
                                    })}
                                </select>
                            </Col>
                        </Row>
                    </Container>
                    <Footer
                        homeImg={home}
                        homeImgRef="/"
                        breadcrumbMainPage="Events"
                        mainPageLink={local_routes.events}
                        breadcrumbSubPage="Event Calendar"
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default EventCalendar;